import { Box, Typography, useTheme } from "@mui/material";
import { DayGroup } from "./DayGroup";
import { MessagesByDay } from "./MyMessagesTypes";

export const MessagesTimeline = ({
  messagesByDay,
  handleOpenDayDialog,
}: {
  messagesByDay: MessagesByDay;
  handleOpenDayDialog: (date: string) => void;
} & React.PropsWithChildren) => {
  const theme = useTheme();
  return (
    <Box>
      <Typography
        variant="h6"
        sx={{
          mb: { xs: 1.5, sm: 2 },
          fontWeight: 700,
          color: theme.palette.text.primary,
          display: "flex",
          alignItems: "center",
          gap: 1,
          fontSize: { xs: "1rem", sm: "1.125rem" },
        }}
      >
        <Box
          sx={{
            width: 3,
            height: 20,
            bgcolor: theme.palette.primary.main,
            borderRadius: 0.5,
          }}
        />
        Message Timeline
      </Typography>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: { xs: 1.5, sm: 2 },
        }}
      >
        {Object.entries(messagesByDay).map(([date, data]) => (
          <DayGroup
            key={date}
            date={date}
            data={data}
            onOpen={() => handleOpenDayDialog(date)}
          />
        ))}
      </Box>
    </Box>
  );
};
